@if (availableValues && formName) {
  <div class="radios-container">
    @for (radioData of availableValues; track radioData) {
      <div
        class="radio"
        [attr.data-display-efektika-tooltip]="radioData.key === formName.value.key ? true : false"
        #radioOption
      >
        <label
          class="radio-container"
          [ngClass]="{
            'radio-container--disabled': disabled  || isSpecificRadioDisabled(radioData),
            'radio-container--selected': radioData.key === formName.value.key,
          }"
        >
          {{ 'newPortfolio.investmentPeriods.' + radioData.key | translate }}
          <input
            [id]="radioData.key"
            type="radio"
            [value]="radioData.value"
            [name]="componentId"
            (change)="selected(radioData)"
            [checked]="radioData.key === formName.value.key"
            [disabled]="disabled || isSpecificRadioDisabled(radioData)"
            [attr.data-cy]="cyId ? (cyId + ' ' + radioData.value) : ''"
          />
          <span class="checkmark"></span>
        </label>
      </div>
    }
  </div>
  @if (efektikaRestrictedPeriods) {
    <div #tooltipDisabledPeriodForEfektikaTooltip style="display: none;">
      <div class="tooltip-content" data-cy="investment-periods-efektika-tooltip">
        <div class="tooltip-text"> {{ 'global.tooltips.efektikaOnlyMonthlyPeriod' | translate }} </div>
      </div>
    </div>
  }
}
